import {
  AddClassRequest,
  Student,
  TeacherDataResponse,
  AddStudentsToClassRequest,
  ImportClassResponse,
  StudentData,
} from "@shared/types";
import axiosInstance from "./axios-instance";

export const getTeacherData = async (): Promise<TeacherDataResponse> => {
  try {
    const response = await axiosInstance.get("/get-teacher-data");
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching teacher data:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const addStudentsToClass = async (studentsData: AddStudentsToClassRequest): Promise<ImportClassResponse> => {
  try {
    const formData = new FormData();
    studentsData.file && formData.append("file", studentsData.file);
    studentsData.students && formData.append("students", JSON.stringify(studentsData.students));
    formData.append("gradeId", studentsData.classId.toString());
    formData.append("schoolId", studentsData.schoolId?.toString() ?? '');
    formData.append("name", studentsData?.name ?? '');
    const response = await axiosInstance.post("/import-class-data", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error: any) {
    // אם יש response.data עם details, זה לא באמת שגיאה אלא partial/error עם מידע
    if (error.response?.data) {
      return error.response.data;
    }
    
    console.error(
      "Error adding students to class:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const addNewClassWithStudents = async (classData: AddClassRequest): Promise<ImportClassResponse> => {
  try {
    const formData = new FormData();

    if (classData.students instanceof File) {
      formData.append("file", classData.students);
    } else if (Array.isArray(classData.students)) {
      formData.append("students", JSON.stringify(classData.students));
    }

    formData.append("schoolId", classData.schoolId?.toString() ?? '');
    formData.append("gradeId", classData.gradeId?.toString() ?? '');
    formData.append("name", classData.name);
    
    
    const response = await axiosInstance.post("/import-class-data", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error: any) {
    // אם יש response.data עם details, זה לא באמת שגיאה אלא partial/error עם מידע
    // במקרה זה, נחזיר את ה-data במקום לזרוק שגיאה
    if (error.response?.data) {
      return error.response.data;
    }
    
    console.error(
      "Error creating class:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteStudent = async (studentId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/students/${studentId}`);
  } catch (error: any) {
    console.error(
      "Error deleting student:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const updateStudent = async (
  studentId: number,
  studentData: Partial<Student>
): Promise<Student> => {
  try {
    const response = await axiosInstance.put(
      `/students/${studentId}`,
      studentData
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating student:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const searchStudents = async (query: string): Promise<Student[]> => {
  try {
    const response = await axiosInstance.get(`/students/search`, {
      params: { q: query },
    });
    return response.data;
  } catch (error: any) {
    console.error(
      "Error searching students:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const getStudentData = async (studentId: number): Promise<StudentData> => {
  try {
    const response = await axiosInstance.get(`/get-student-data/${studentId}`);
    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching student data:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
